import { useContext } from "react";
import { useSelector } from "react-redux";
import Radio from "@mui/material/Radio";
import { ComponentPropsContext, ComponentPropsContextApi } from "layouts/Flow Designer/context";

const RadioInput = ({ name, value, allowEditWorkflow }) => {
  const { actionForm } = useContext(ComponentPropsContext);
  const { setActionForm } = useContext(ComponentPropsContextApi);
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  const handleRadioBtnChange = (e) => {
    setActionForm({ ...actionForm, [name]: { value: e.target.value } });
  };

  return (
    <Radio
      key={value}
      sx={{ marginTop: "16px", marginRight: "16px" }}
      onChange={handleRadioBtnChange}
      value={value}
      name="radio-buttons"
      slotProps={{
        input: {
          "aria-label": "A"
        }
      }}
      disabled={isFlowActive || !allowEditWorkflow}
    />
  );
};

export default RadioInput;
